export default "__VITE_ASSET__GokRKCEz__"